import { createFileRoute } from "@tanstack/react-router";
import { BillingPlans } from "@/components/billing/billing-plans";
import { PublicLayout } from "@/components/public-layout";
import { buildBreadcrumb, buildFAQ, buildProductOffers, jsonLdScript } from "@/lib/seo/json-ld";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";

const PRICING_FAQ_ITEMS = [
	{
		question: "Is there a free plan?",
		answer:
			"Yes. The Free plan includes 5 tasks per month and is free forever. No credit card required.",
	},
	{
		question: "Can I cancel anytime?",
		answer:
			"Yes. All paid plans are month-to-month with no contracts. Cancel anytime from your dashboard.",
	},
	{
		question: "What happens when I exceed my task limit?",
		answer:
			"Tasks pause until the next billing cycle. You can upgrade your plan at any time to increase your limit.",
	},
	{
		question: "Do you offer annual billing?",
		answer:
			"Yes. Annual billing gives you 12 months for the price of 10 — saving you two months per year.",
	},
	{
		question: "What payment methods do you accept?",
		answer:
			"We accept all major credit cards through Stripe. Enterprise customers can pay via invoice.",
	},
];

export const Route = createFileRoute("/pricing")({
	head: () => {
		const canonical = getCanonical("/pricing");
		const meta = buildMetaTags({
			title: "AI Teammate Pricing",
			description:
				"Simple pricing for autonomous AI teammates. Start free and scale as you automate more.",
			canonical,
			ogType: "website",
		});

		const schemas = [
			buildFAQ(PRICING_FAQ_ITEMS),
			buildBreadcrumb([
				{ name: "Home", url: getCanonical("/") },
				{ name: "Pricing", url: canonical },
			]),
			buildProductOffers([
				{ name: "Free", price: 0, description: "5 tasks per month. Free forever." },
				{ name: "Pro", price: 29, description: "100 tasks per month. Standard support." },
				{ name: "Max", price: 99, description: "500+ tasks per month. Priority support." },
			]),
		];

		return {
			meta,
			links: buildLinks({ canonical }),
			scripts: schemas.map(jsonLdScript),
		};
	},

	component: PricingPage,
});

function PricingPage() {
	return (
		<PublicLayout className="py-10">
			<BillingPlans variant="public" />
		</PublicLayout>
	);
}
